import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

//styles
import { DefaultButton } from 'components/styled/Button';

//components
import Loader from './Loader';

export type colorType =
  | 'red'
  | 'green'
  | 'light-green'
  | 'black'
  | 'blue'
  | 'red-outline'
  | 'primary-outline'
  | 'ghost-blue'
  | 'ghost-black'
  | 'ghost-purple'
  | 'light-blue'
  | 'yellow'
  | 'transparent'
  | 'white'
  | 'white-green'
  | 'grey'
  | 'light-grey'
  | 'dark-grey'
  | 'orange'
  | 'airbnb-pink'
  | 'purple'
  | 'soon-blue';

interface IButton {
  type?: 'button' | 'submit' | 'reset' | undefined;
  label: string;
  color?: colorType;
  isFetching?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  width?: string;
  borderRadius?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  borderTopLeftRadius?: boolean;
  borderTopRightRadius?: boolean;
  borderBottomLeftRadius?: boolean;
  margin?: string;
  gap?: string;
  height?: string;
  padding?: string;
  justifyContent?: string;
  textTransform?: string;
  fontSize?: string;
}

export const Button = ({
  type = 'button',
  label,
  color = 'white',
  isFetching = false,
  width,
  onClick,
  borderRadius,
  disabled,
  leftIcon,
  rightIcon,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  margin,
  gap,
  height,
  padding,
  justifyContent,
  textTransform,
  fontSize,
}: IButton) => {
  const { t } = useTranslation();

  return (
    <DefaultButton
      onClick={onClick}
      disabled={!!isFetching || disabled}
      color={color}
      type={type}
      width={width}
      height={height}
      borderRadius={borderRadius}
      borderTopLeftRadius={borderTopLeftRadius}
      borderTopRightRadius={borderTopRightRadius}
      borderBottomLeftRadius={borderBottomLeftRadius}
      margin={margin}
      gap={gap}
      padding={padding}
      justifyContent={justifyContent}
      textTransform={textTransform}
      fontSize={fontSize}
    >
      {isFetching && <Loader />}
      {leftIcon}
      {!!label && t(label)}
      {rightIcon}
    </DefaultButton>
  );
};
